// extracted by mini-css-extract-plugin
export default {"overlayScreen":"howItWorks_overlayScreen__GeSM-","overlayScreenDefault":"howItWorks_overlayScreenDefault__nVxWs"};